export const REPORT_NAME = 'Password Sharing Report';
export const GET_USERS_TASK_NAME = 'password-sharing-report.get-users';
export const GET_USERS_TASK_PROGRESS_LABEL = 'Searching for users for the report...';
export const TASK_NAME = 'password-sharing-report';
export const FILE_NAME = 'PitchBook-password-sharing-report';
export const STATIC_FILE_HEADERS = {
    userId: 'User ID',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    timeDifference: 'Time Difference',
    sameIP: 'Same IP Address',
    sameBrowser: 'Same Browser',
    firstLogin: 'First Login',
    firstLoginIP: 'IP Address First Login',
    reverseDNSIPFirstLogin: 'IP Reverse DNS Lookup First Login',
    lastEventFirstLogin: 'Last Event First Login',
    lastLogin: 'Last Login',
    lastLoginIP: 'IP Address Last Login',
    reverseDNSIPLastLogin: 'IP reverse DNS Lookup Last Login',
    agentFirstLogin: 'Agent First Login',
    agentLastLogin: 'Agent Last Login',
    cookieId: 'Cookie ID',
    eventSource: 'Event Source',
    firstDeviceType: 'First Device Type',
    lastDeviceType: 'Last Device Type',
    firstDeviceId: 'First Device ID',
    lastDeviceId: 'Last Device ID',
};

export const CHUNK_SIZE = 100;


export const DATE_RANGE_NAME = 'password-sharing-data-range-select';
export const DATE_RANGE_OPTIONS = {
    CUSTOM: {
        value: 'custom',
        label: 'Custom',
    },
    LAST_MONTH: {
        value: 'last-month',
        label: 'Last Month',
    },
    CURRENT_LICENSE: {
        value: 'current-license',
        label: 'Current License',
    },
};

export const SELECT_NAME = 'password-sharing-report-select';
export const SELECT_OPTIONS = {
    USERS: {
        value: 'users',
        label: 'Users',
    },
    GROUPS: {
        value: 'groups',
        label: 'Group',
    },
};
